export const SHIPPING_CHARGE = 0;
export const FREE_SHIPPING_THRESHOLD = 0;

export const calculateShippingPrice = (itemsPrice = 0) => {
  return 0;
};

export const calculateTotalPrice = ({ itemsPrice = 0, taxPrice = 0 } = {}) =>
  (Number(itemsPrice) || 0) + calculateShippingPrice(itemsPrice) + (Number(taxPrice) || 0);
